exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination[data-v-823ecc8c] {\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  top: -12px;\n  padding-right: 80px;\n  background-color: #fafafa;\n}\n.pagination__range[data-v-823ecc8c] {\n  font-size: 14px;\n  padding: 0 12px;\n}\n.pagination__arrow--disabled[data-v-823ecc8c] {\n  opacity: 0.38;\n  padding: 12px;\n  position: relative;\n  top: 1px;\n}\n", ""]);

// exports
